export function* uidGenerator(prefix) {
  var initId = 0;
  while (true) {
    yield prefix + "-" + initId;
    initId++;
  }
}